<script lang="ts">
  const year = new Date().getFullYear();

  const services = [
    { label: 'AI Workflow Automation', href: '/#services' },
    { label: 'AI-Ready Websites', href: '/#services' },
    { label: 'Growth Partner', href: '/#pricing' },
    { label: 'ROI Calculator', href: '/tools/automation-roi-calculator' },
  ];

  const solutions = [
    { label: 'Logistics', href: '/solutions/logistics' },
    { label: 'Real Estate', href: '/solutions/real-estate' },
    { label: 'E-Commerce', href: '/solutions/ecommerce' },
    { label: 'SaaS', href: '/solutions/saas' },
  ];

  const company = [
    { label: 'About', href: '/about' },
    { label: 'Blog', href: '/blog' },
    { label: 'Legal & Company', href: '/legal' },
    { label: 'Privacy Policy', href: '/privacy' },
  ];
</script>

<footer class="border-t border-dim-6 bg-void mt-32">
  <div class="max-w-6xl mx-auto px-4 py-16">
    <div class="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 gap-10 mb-12">

      <!-- Brand -->
      <div class="md:col-span-2 lg:col-span-2">
        <div class="flex items-center mb-6 group">
          <span class="font-display font-bold text-2xl tracking-tighter text-content group-hover:text-[#C9A87C] transition-colors">
            bleunk<span class="text-[#C9A87C]">.</span>
          </span>
        </div>
        <p class="text-dim-50 text-sm leading-relaxed max-w-xs mb-5">
          AI automation studio. We automate your business workflows with AI and build the web infrastructure to run them — on a deadline we guarantee.
        </p>
        <div class="text-dim-30 text-xs space-y-0.5 font-mono">
          <div>hello@bleunk.com</div>
        </div>
      </div>

      <!-- Services -->
      <div>
        <h3 class="text-dim-40 text-xs font-semibold uppercase tracking-widest mb-4">Services</h3>
        <ul class="space-y-2.5">
          {#each services as item}
            <li>
              <a href={item.href} class="text-dim-60 text-sm hover:text-content focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A87C]/50 rounded transition-colors">
                {item.label}
              </a>
            </li>
          {/each}
        </ul>
      </div>

      <!-- Solutions -->
      <div>
        <h3 class="text-dim-40 text-xs font-semibold uppercase tracking-widest mb-4">Solutions</h3>
        <ul class="space-y-2.5">
          {#each solutions as item}
            <li>
              <a href={item.href} class="text-dim-60 text-sm hover:text-content focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A87C]/50 rounded transition-colors">
                {item.label}
              </a>
            </li>
          {/each}
        </ul>
      </div>

      <!-- Company -->
      <div>
        <h3 class="text-dim-40 text-xs font-semibold uppercase tracking-widest mb-4">Company</h3>
        <ul class="space-y-2.5">
          {#each company as item}
            <li>
              <a href={item.href} class="text-dim-60 text-sm hover:text-content focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A87C]/50 rounded transition-colors">
                {item.label}
              </a>
            </li>
          {/each}
          <li>
            <a href="mailto:hello@bleunk.com" class="text-dim-60 text-sm hover:text-content focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A87C]/50 rounded transition-colors">
              Contact
            </a>
          </li>
        </ul>
      </div>

    </div>

    <div class="pt-8 border-t border-dim-5 flex flex-col sm:flex-row items-center justify-between gap-4">
      <p class="text-dim-30 text-xs">
        © {year} Bleunk Technologies Inc. All rights reserved.
      </p>
      <div class="flex items-center gap-2 text-dim-30 text-xs">
        <span class="relative flex h-1.5 w-1.5">
          <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#7A9E90] opacity-75"></span>
          <span class="relative inline-flex rounded-full h-1.5 w-1.5 bg-[#7A9E90]"></span>
        </span>
        All systems operational
      </div>
    </div>
  </div>
</footer>
